import { categories } from "@/mocks/gua";

export default function Categories() {
  return (
    <section id="column" className="mt-16 scroll-mt-24 px-4 md:mt-24 md:px-6">
      <div className="mx-auto max-w-[1240px] rounded-xl bg-background-100/60 px-4 py-8 md:px-8 md:py-10">
        <div className="mb-6 flex flex-col justify-between gap-2 md:flex-row md:items-end">
          <div>
            <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-secondary-600">热评栏目</p>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">按栏目吃瓜，更快找到你想看的那口</h2>
          </div>
          <a href="#fresh" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700">
            看看今日速递 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <article
              key={c.name}
              className="group flex cursor-pointer items-center gap-4 rounded-lg bg-background-50 p-3 transition-colors hover:shadow-soft"
            >
              <div className="relative h-20 w-24 shrink-0 overflow-hidden rounded-md sm:h-24 sm:w-28">
                <img
                  src={c.img}
                  alt={`${c.name} 栏目封面图`}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              <div className="flex min-w-0 flex-1 flex-col gap-1">
                <div className="flex items-center justify-between gap-2">
                  <h3 className="flex items-center gap-1.5 whitespace-nowrap font-heading text-base font-semibold text-foreground-900">
                    <i className={`text-primary-500 ${c.icon}`} />
                    {c.name}
                  </h3>
                  <span className="whitespace-nowrap text-xs text-foreground-400">{c.count} 篇</span>
                </div>
                <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">{c.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}